import React, { FC } from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { scale } from '@components/frame';
import { CollapsedSection as CollapsedSectionType } from './types';
import SimpleButton, { SimpleButtonVariant } from '@components/operatorPanel/components/elements/buttons/SimpleButton';
import { isPhone, isWeb } from '@helpers';
import { COLLAPSED_SECTION_DIMENSIONS } from './constants/diffView.constants';
import { font } from '@styles/fonts';
import i18n from 'i18n-js';
import { WithColor } from '@styles/colors';

interface CollapsedSectionProps extends WithColor {
  section: CollapsedSectionType;
  onExpand: (section: CollapsedSectionType) => void;
}

const CollapsedSection: FC<CollapsedSectionProps> = ({ C, section, onExpand }) => {
  const isTablet = !isPhone && !isWeb;

  const pluralSuffix = section.count !== 1 ? 's' : '';
  const buttonLabel = i18n.t('Show {{count}} Line{{suffix}}', { count: section.count, suffix: pluralSuffix });
  const capsuleTextColor = C(C.scheme === 'dark' ? 'Button/Dark/Secondary Text' : 'Button/Light/Secondary Text');
  const minWidth = isTablet ? COLLAPSED_SECTION_DIMENSIONS.width : scale(COLLAPSED_SECTION_DIMENSIONS.width);
  const height = isTablet ? COLLAPSED_SECTION_DIMENSIONS.height : scale(COLLAPSED_SECTION_DIMENSIONS.height);
  const paddingHorizontal = isTablet ? 12 : scale(12);
  const verticalMargin = isTablet ? COLLAPSED_SECTION_DIMENSIONS.verticalGap : scale(COLLAPSED_SECTION_DIMENSIONS.verticalGap);

  return (
    <View style={[styles.container, isTablet && styles.tabletContainer, { marginVertical: verticalMargin }]}>
      <SimpleButton
        C={C}
        scale={scale}
        variant={SimpleButtonVariant.Capsule}
        style={[
          styles.button,
          {
            minWidth,
            height,
            paddingHorizontal,
          },
        ]}
        onPress={() => onExpand(section)}
      >
        <Text style={[font['Button 2'], { color: capsuleTextColor }]}>{buttonLabel}</Text>
      </SimpleButton>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    alignSelf: 'flex-start',
  },
  tabletContainer: {
    alignItems: 'flex-start',
  },
  button: {
  },
});

export default CollapsedSection;
